var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"pink","dark":""},on:{"click":function($event){_vm.$emit('click')}}},[_vm._v("Finish")])}
var staticRenderFns = []

export { render, staticRenderFns }